export default "__VITE_ASSET__DqqDxs14__"